module.exports = __webpack_public_path__ + "img/s_top_04.dbb8874a.png";